module.exports = __webpack_public_path__ + "static/media/syncui_126.5e27c6da.ico";